import React from 'react';
import PropTypes from 'prop-types';

import Progress from '../../../Progress/Progress';
import ProgramsLink from '../ProgramsLink/ProgramsLink';
import CourseName from '../../../CourseName/CourseName';
import { useLocation, useNavigate } from 'react-router-dom';
import ButtonIcon from '../../../../common/ButtonIcon/ButtonIcon';
import VocabularyButton from '../../../../common/VocabularyButton/VocabularyButton';

import './card-program.style.scss';
import { homeworkColors } from '../../../schedule/constants';
import CertificateButton from '../../../Certificates/CertificateButton';

const ProgramsCard = ({ course }) => {
  const lastLesson = course.last_lesson || null;
  const navigate = useNavigate();
  const location = useLocation();

  const setHomeworkPage = () => {
    if (!lastLesson) return;
    localStorage.setItem('event', JSON.stringify(lastLesson));
    localStorage.setItem('eventId', JSON.stringify(lastLesson.event_id));
    localStorage.setItem('realHomeworkId', JSON.stringify(lastLesson.homework_id));
    navigate('/homework', { state: { from: location.pathname } });
  };

  const setLink = (link) => {
    if (link) {
      window.open(link, '_blank');
    }
  };

  const shouldPulse = lastLesson && lastLesson.homework_icon_color != 4;
  const hex = lastLesson ? homeworkColors[lastLesson.homework_icon_color] : null;
  const pulseStyle = shouldPulse ? { '--pulse-color': hex } : {};

  return (
    <div className="card-program">
      <CourseName
        img={course.image}
        name={course.direction_name}
        level={course.program_name}
        isViolet={true}
      />

      {lastLesson && (
        <div className="card-program-block">
          <div className="card-program-block__title">Матеріали з останнього заняття</div>
          <div className="program-item__btns">
            {lastLesson.presentation_link && (
              <ButtonIcon
                classes="program-item__btn"
                icon="monitor"
                btnBg="white"
                iconColor="green"
                btnSize="lg"
                iconSize="md"
                onClick={() => setLink(lastLesson.presentation_link)}
              />
            )}
            {lastLesson.google_pdf_url && (
              <ButtonIcon
                classes="program-item__btn"
                icon="pdf"
                btnBg="white"
                iconColor="green"
                btnSize="lg"
                iconSize="md"
                onClick={() => setLink(lastLesson.google_pdf_url)}
              />
            )}
            {lastLesson.youtube_link && (
              <ButtonIcon
                classes="program-item__btn"
                icon="youtube"
                btnBg="white"
                iconColor="green"
                btnSize="lg"
                iconSize="md"
                onClick={() => setLink(lastLesson.youtube_link)}
              />
            )}
            {lastLesson.vocabulary_link && (
              <ButtonIcon
                classes="program-item__btn"
                icon="list"
                btnBg="white"
                iconColor="green"
                btnSize="lg"
                iconSize="md"
                onClick={() => setLink(lastLesson.vocabulary_link)}
              />
            )}

            <VocabularyButton classes='program-item__btn' token={lastLesson?.vocabulary_token} />
            {lastLesson.video_url && (
              <ButtonIcon
                classes="program-item__btn"
                icon="video"
                btnBg="white"
                iconColor="green"
                btnSize="lg"
                iconSize="md"
                onClick={() => setLink(lastLesson.video_url)}
              />
            )}

            {lastLesson.is_show_homework && (
              <div className="homework-icon-wrapper">
                {lastLesson.is_show_icon_new && (
                  <div className="new-badge">new</div>
                )}
                <ButtonIcon
                  classes={`program-item__btn ${shouldPulse ? 'pulsing-icon' : ''}`}
                  icon="book"
                  btnBg="white"
                  iconColor={homeworkColors[lastLesson.homework_icon_color]}
                  btnSize="lg"
                  iconSize="md"
                  onClick={setHomeworkPage}
                  style={pulseStyle}
                />
              </div>
            )}
          </div>
        </div>
      )}

      <div className="card-program-block">
        <div className="card-program-block__title">Пройдено</div>
        <ProgramsLink
          count={course.event_lesson_count}
          link="/course/program"
          onClick={() =>
            localStorage.setItem('programId', JSON.stringify(course.program_id))
          }
        />
      </div>

      <div className="card-program-block">
        <div className="card-program-block__title">Всього</div>
        <div className="card-program-block__desc">
          {course.event_lesson_count}/{course.study_lesson_count}
        </div>
      </div>

      <Progress progress={course.lesson_persent} />

      <CertificateButton
        programId={course.program_id}
        programTitle={course.direction_name}
        variant="card"
      />
    </div>
  );
};

ProgramsCard.propTypes = {
  course: PropTypes.object.isRequired,
};

export default ProgramsCard;